const actions = {
    PUBLIC_TRANSACTION_READ_REQUEST: 'PUBLIC_TRANSACTION_READ_REQUEST',
    PUBLIC_TRANSACTION_READ_SUCCESS: 'PUBLIC_TRANSACTION_READ_SUCCESS',
    PUBLIC_TRANSACTION_READ_ERROR: 'PUBLIC_TRANSACTION_READ_ERROR',
    PUBLIC_TRANSACTION_READ_V2_REQUEST: 'PUBLIC_TRANSACTION_READ_V2_REQUEST',
    PUBLIC_TRANSACTION_READ_V2_SUCCESS: 'PUBLIC_TRANSACTION_READ_V2_SUCCESS',
    PUBLIC_TRANSACTION_READ_V2_ERROR: 'PUBLIC_TRANSACTION_READ_V2_ERROR',

    PUBLIC_TRANSACTION_READ_V3_REQUEST: 'PUBLIC_TRANSACTION_READ_V3_REQUEST',
    PUBLIC_TRANSACTION_READ_V3_SUCCESS: 'PUBLIC_TRANSACTION_READ_V3_SUCCESS',
    PUBLIC_TRANSACTION_READ_V3_ERROR: 'PUBLIC_TRANSACTION_READ_V3_ERROR',

    PUBLIC_TRANSACTION_RESET_STATE: 'PUBLIC_TRANSACTION_RESET_STATE',
    PUBLIC_TRANSACTION_READ_FILE_REQUEST: 'PUBLIC_TRANSACTION_READ_FILE_REQUEST',
    PUBLIC_TRANSACTION_READ_FILE_SUCCESS: 'PUBLIC_TRANSACTION_READ_FILE_SUCCESS',
    PUBLIC_TRANSACTION_READ_FILE_ERROR: 'PUBLIC_TRANSACTION_READ_FILE_ERROR',
    PUBLIC_TRANSACTION_SET_FILES: 'PUBLIC_TRANSACTION_SET_FILES',
    PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_REQUEST: 'PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_REQUEST',
    PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_SUCCESS: 'PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_SUCCESS',
    PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_ERROR: 'PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_ERROR',

    PUBLIC_TRANSACTION_REQUEST_E_INVOICE_REQUEST: 'PUBLIC_TRANSACTION_REQUEST_E_INVOICE_REQUEST',
    PUBLIC_TRANSACTION_REQUEST_E_INVOICE_SUCCESS: 'PUBLIC_TRANSACTION_REQUEST_E_INVOICE_SUCCESS',
    PUBLIC_TRANSACTION_REQUEST_E_INVOICE_ERROR: 'PUBLIC_TRANSACTION_REQUEST_E_INVOICE_ERROR',

    PUBLIC_TRANSACTION_REJECT_E_INVOICE_REQUEST: 'PUBLIC_TRANSACTION_REJECT_E_INVOICE_REQUEST',
    PUBLIC_TRANSACTION_REJECT_E_INVOICE_SUCCESS: 'PUBLIC_TRANSACTION_REJECT_E_INVOICE_SUCCESS',
    PUBLIC_TRANSACTION_REJECT_E_INVOICE_ERROR: 'PUBLIC_TRANSACTION_REJECT_E_INVOICE_ERROR',

    read: (id, cs, ct, emails) => ({
        type: actions.PUBLIC_TRANSACTION_READ_REQUEST,
        id,
        cs,
        ct,
        emails,
    }),
    readV2: (id, subdomain, transactionEmailId, formDesignId) => ({
        type: actions.PUBLIC_TRANSACTION_READ_V2_REQUEST,
        id,
        subdomain,
        transactionEmailId,
        formDesignId,
    }),
    readV3: (hash, subdomain, transactionEmailId, formDesignId) => ({
        type: actions.PUBLIC_TRANSACTION_READ_V3_REQUEST,
        hash,
        subdomain,
        transactionEmailId,
        formDesignId,
    }),
    resetState: () => ({
        type: actions.PUBLIC_TRANSACTION_RESET_STATE,
    }),
    setFiles: files => ({
        type: actions.PUBLIC_TRANSACTION_SET_FILES,
        files,
    }),
    readFile: fileId => ({
        type: actions.PUBLIC_TRANSACTION_READ_FILE_REQUEST,
        fileId,
    }),
    createPayexPayment: (request, openInNewTab) => ({
        type: actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_REQUEST,
        request,
        openInNewTab,
    }),
    requestEInvoice: (request, hash, subdomain) => ({
        type: actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_REQUEST,
        request,
        hash,
        subdomain,
    }),
    rejectEInvoice: (request, hash, subdomain) => ({
        type: actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_REQUEST,
        request,
        hash,
        subdomain,
    }),
};
export default actions;
